import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionAuthLoginPayload,
	IActionAuthLoginPayloadDone,
	IActionAuthLoginPayloadError,
} from './types';

export const authLogin = actionCreatorAsync<
	IActionAuthLoginPayload,
	IActionAuthLoginPayloadDone,
	IActionAuthLoginPayloadError
>(
	'authLogin',
	async (params) => {
		const { login, password } = params;
		const { data } = await Api.auth.login({
			body: { login, password },
		});

		return data;
	},
);
